import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export type ExtractedProjectPhase = {
  name: string;
  status: 'pending' | 'in_progress' | 'completed' | 'blocked';
  expectedStartDate?: string;
  expectedEndDate?: string;
  responsibleParty?: string;
  dependsOnPhaseNames?: string[];
  notes?: string;
  suggestedTasks?: string[];
};

export type ExtractProjectPhasesResponse = {
  phases: ExtractedProjectPhase[];
  summary: string;
};

export function extractProjectPhasesErrorMessage(err: unknown): string {
  if (err && typeof err === 'object' && 'message' in err) {
    const message = String((err as { message: string }).message);
    if (message && !message.startsWith('Firebase')) {
      return message;
    }
  }
  if (err && typeof err === 'object' && 'code' in err) {
    const code = String((err as { code: string }).code);
    if (code === 'functions/invalid-argument') {
      return 'Please provide at least 50 characters of text to analyze.';
    }
    if (code === 'functions/unauthenticated') {
      return 'Sign in to extract project phases.';
    }
    if (code === 'functions/unavailable') {
      return 'Analysis service is temporarily unavailable. Try again.';
    }
    if (code === 'functions/failed-precondition') {
      return 'OpenAI API key not configured.';
    }
    if (code === 'functions/internal' || code === 'functions/deadline-exceeded') {
      return 'Analysis failed. Please try again.';
    }
  }
  return err instanceof Error ? err.message : 'Failed to extract project phases.';
}

export async function extractProjectPhases(text: string): Promise<ExtractProjectPhasesResponse> {
  const fn = httpsCallable<{ text: string }, ExtractProjectPhasesResponse>(
    functions,
    'extractProjectPhases'
  );
  const result = await fn({ text: text.trim() });
  return result.data;
}
